import React, {memo} from "react"
import Skeleton from 'react-loading-skeleton';

export const DescriptionSkeleton = memo(() => (
    <Skeleton height={14} width={'100%'}/>
));
